export default {
  save: 'Save',
  saving: 'Saving',
  scenario_execution: 'Scenario Execution',
  scheduled: 'Scheduled',
  scheduling: 'Scheduling',
  service: 'Service',
  score: 'Score',
  search: 'Search',
  settings: 'Settings',
  status_check: 'Health Check',
  status_checks: 'Health Checks',

  // Used in our Scenario and Recent Attack cards to display the steps and/or details of each. This text will be converted
  // from snake_case to Title Case and displayed in the UI.
  steps: 'Steps',
  summary: 'Summary'
}
